export const MuiPaper = {
  styleOverrides: {
    root: {
      '.MuiList-root': {
        padding: '7px 0',
        margin: '0 3px',

        '.MuiMenuItem-root': {
          padding: '8px 13px 8px',
          borderRadius: '6px',
          fontSize: '16px',
          lineHeight: '20.8px',

          '&:hover, &.Mui-focused': {
            background: 'rgba(201, 255, 235, 1)',
          },

          '&.Mui-selected': {
            background: 'rgba(30, 237, 159, 1)',
          },
        },
      },
    },
  },
};
